module.exports = __webpack_public_path__ + "static/eBusiness-platform-6b7abcf635767abbd7bce57be8c85df2.svg";